function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.29289 0.292893C8.38877 0.197017 8.49927 0.124678 8.61722 0.0758787L9.70711 0.292893L9.7075 0.293291L13.7071 4.29289C14.0976 4.68342 14.0976 5.31658 13.7071 5.70711C13.3166 6.09763 12.6834 6.09763 12.2929 5.70711L10 3.41421V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V3.41421L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289L8.29289 0.292893ZM8.61722 0.0758787L9.70498 0.290776C9.52419 0.111056 9.27506 0 9 0C8.86441 0 8.73512 0.0269854 8.61722 0.0758787ZM2 11C2 10.4477 1.55228 10 1 10C0.447715 10 0 10.4477 0 11V19C0 19.7957 0.31607 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H15C15.7957 22 16.5587 21.6839 17.1213 21.1213C17.6839 20.5587 18 19.7957 18 19V11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V11Z",
  fill: "#BDBDBD"
});

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9430f30a.svg";
export { ForwardRef as ReactComponent };